import { ModelEndpointResponse } from 'app/base/endpoints/types';
import TermsOfServiceCollection from '../collections/TermsOfServiceCollection';
import TermsOfService from '../models/TermsOfService';
import BaseEndpoint from '@/app/base/endpoints/BaseEndpoint';
import { ModelType } from '@/app/base/schemas/BaseSchema';

/**
 * Unauthenticated read of the latest published terms, resolved by locale. Hits the public
 * `v1/common/terms-of-services/-actions/latest?locale=` route (no auth, no tenant), which falls back
 * to be-fr when the locale has no terms. Used by the signup GC viewer (AcceptModal view mode), where
 * the tenant-scoped TermsOfServiceEndpoint.latest() is not reachable.
 */
export default class PublicTermsOfServiceEndpoint extends BaseEndpoint<TermsOfService, TermsOfServiceCollection> {
    model: ModelType = ModelType.TERMS_OF_SERVICES;
    path = 'common/terms-of-services';

    async latestForLocale(locale: string): Promise<ModelEndpointResponse<TermsOfService>> {
        return await this.request<ModelEndpointResponse<TermsOfService>>({
            method: 'GET',
            path: `-actions/latest?locale=${encodeURIComponent(locale)}`,
        });
    }
}
